import { Outlet, useLocation } from 'react-router-dom';

import InlineStyled from '../../CommonComponents/InlineStyled/InlineStyled';
import Navbar from '../../CommonComponents/Navbar/Navbar';
import { DOC_CHAT, DOC_COMPARE } from '../../Constants/commonConstants';
import SettingsNavbar from './SettingsNavbar';

const SettingsPageLayout = () => {
  const { pathname } = useLocation();
  const isDocCompare = pathname?.includes('doccompare');
  return (
    <>
      <Navbar product={isDocCompare ? DOC_COMPARE : DOC_CHAT} />
      <InlineStyled
        $style={{
          height: 'calc(100vh - 68px)',
          display: 'flex',
        }}
      >
        <SettingsNavbar pathname={pathname} isDocCompare={isDocCompare} />
        <InlineStyled
          $style={{
            height: '100%',
            overflow: 'auto',
            padding: '24px',
            background: '#fff',
            flexGrow: 1,
          }}
        >
          <Outlet />
        </InlineStyled>
      </InlineStyled>
    </>
  );
};

export default SettingsPageLayout;
